export const PelletContentPagesList = [
  {
    name: `Pelletsheizung`,
    title: `Erfahren Sie alles was Sie wissen müssen über eine Pelletsheizung`,
    link: { path: `/pelletspreise/pellets-ratgeber/pelletsheizung` },
    externalLink: false,
  },
  {
    name: `Holzpellets Qualität`,
    title: `Erfahren Sie alles über die Qualität von Holzpellets`,
    link: { path: `/pelletspreise/pellets-ratgeber/holzpellets-qualitaet` },
    externalLink: false,
  },
  {
    name: `Pelletheizung Vor- und Nachteile`,
    title: `Erfahren Sie alles über die Vor- und Nachteile einer Pelletheizung`,
    link: {
      path: `/pelletspreise/pellets-ratgeber/pelletheizung-vorteile-nachteile`,
    },
    externalLink: false,
  },
  {
    name: `Heizwert Pellets`,
    title: `Erfahren Sie alles über den Heizwert von Pellets`,
    link: { path: `/pelletspreise/pellets-ratgeber/heizwert-pellets` },
    externalLink: false,
  },
  {
    name: `Wie werden Pellets hergestellt?`,
    title: `Erfahren Sie alles über die Herstellung von Pellets`,
    link: { path: `/pelletspreise/pellets-ratgeber/pellets-herstellung` },
    externalLink: false,
  },
  {
    name: `Pelletlager`,
    title: `Erfahren Sie alles über die Lagerung von Pellets`,
    link: { path: `/pelletspreise/pellets-ratgeber/pelletlager` },
    externalLink: false,
  },
  {
    name: `Pelletlager Reinigung`,
    title: `Erfahren Sie alles über die Reinigung von Pelletlagern`,
    link: { path: `/pelletspreise/pellets-ratgeber/pelletlager-reinigung` },
    externalLink: false,
  },
  {
    name: `Pellets Preis Zusammensetzung`,
    title: `Erfahren Sie alles über die Preiszusammensetzung von Holzpellets`,
    link: {
      path: `/pelletspreise/pellets-ratgeber/holzpellets-preis-zusammensetzung`,
    },
    externalLink: false,
  },
  {
    name: `Vergleich Sackware vs. lose Ware`,
    title: `Erfahren Sie alles über den Unterschied zwischen Sackware und loser Ware`,
    link: {
      path: `/pelletspreise/pellets-ratgeber/pellets-sackware-lose-ware-vergleich`,
    },
    externalLink: false,
  },
  {
    name: `Pelletsverbrauch`,
    title: `Erfahren Sie alles über den Pelletsverbrauch`,
    link: { path: `/pelletspreise/pellets-ratgeber/pelletsverbrauch` },
    externalLink: false,
  },
  {
    name: `Pellets-Zertifikate`,
    title: `Pellets-Zertifikate im Überblick: ENplus, DINplus, FSC und PEFC erklärt`,
    link: { path: `/pelletspreise/pellets-ratgeber/pellets-zertifikate` },
    externalLink: false,
  },
  {
    name: `Pelletheizung Asche`,
    title: `Asche bei der Pelletheizung: Entsorgung und Nutzung`,
    link: { path: `/pelletspreise/pellets-ratgeber/pelletheizung-asche` },
    externalLink: false,
  },
  {
    name: `Pelletheizung Wirkungsgrad`,
    title: `Pelletheizung Wirkungsgrad: Was die Kennzahl für Ihre Heizkosten bedeutet`,
    link: {
      path: `/pelletspreise/pellets-ratgeber/pelletheizung-wirkungsgrad`,
    },
    externalLink: false,
  },
  {
    name: `Pelletheizung Wartung & Kosten`,
    title: `Pelletheizung Wartung und Kosten: Was auf Betreiber zukommt`,
    link: {
      path: `/pelletspreise/pellets-ratgeber/pelletheizung-wartung-kosten`,
    },
    externalLink: false,
  },
  {
    name: `Öl auf Pellets`,
    title: `Von Öl auf Pellets umsteigen: Schritt-für-Schritt-Anleitung`,
    link: {
      path: `/pelletspreise/pellets-ratgeber/oel-auf-pellets`,
    },
    externalLink: false,
  },
  {
    name: `Gas auf Pellets`,
    title: `Von Gas auf Pellets umsteigen: Schritt-für-Schritt-Anleitung`,
    link: {
      path: `/pelletspreise/pellets-ratgeber/gas-auf-pellets`,
    },
    externalLink: false,
  },
  {
    name: `Pelletofen vs. Pelletheizung`,
    title: `Pelletofen vs. Pelletheizung: Was ist der Unterschied?`,
    link: {
      path: `/pelletspreise/pellets-ratgeber/pelletofen-vs-pelletheizung`,
    },
    externalLink: false,
  },
  {
    name: `Pelletofen`,
    title: `Pelletofen als Zusatzheizung: Wann es sich lohnt und wann nicht`,
    link: {
      path: `/pelletspreise/pellets-ratgeber/pelletofen-zusatzheizung`,
    },
    externalLink: false,
  },
  {
    name: `Pelletlager selbst bauen`,
    title: `Pelletlager selbst bauen: Planung, Anforderungen und was Fachleute übernehmen müssen`,
    link: {
      path: `/pelletspreise/pellets-ratgeber/pelletlager-selbst-bauen`,
    },
    externalLink: false,
  },
];
